import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { setCalendarCountryHolidaysAction } from 'editor/src/store/design/slice';
import { setRequestedCalendarCountriesAction } from 'editor/src/store/gridConfig/slice';
import { CalendarCountriesEvents, CountryGridEvent } from 'editor/src/store/gridConfig/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import type { RootState } from 'editor/src/store/index';

import { isSameCountries } from 'editor/src/util/calendar/calendarCountries';

// The holidays are saved with the design and printed, so a malformed one is dropped rather than stored.
const isCountryHoliday = (event: Partial<CountryGridEvent>, countries: string[]): event is CountryGridEvent =>
  typeof event?.title === 'string' &&
  typeof event.date === 'string' &&
  !Number.isNaN(Date.parse(event.date)) &&
  typeof event.country === 'string' &&
  countries.includes(event.country);

const receiveCalendarCountriesEventsOperation =
  (payload: CalendarCountriesEvents) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    // Only the answer to the selection still waiting for one: anything else is stale or was never asked for.
    if (!isSameCountries(getState().gridDesigns.requestedCalendarCountries ?? undefined, payload?.countries)) {
      return;
    }

    const events = Array.isArray(payload.events)
      ? payload.events.filter((event) => isCountryHoliday(event, payload.countries))
      : [];
    batch(() => {
      dispatch(
        setCalendarCountryHolidaysAction({
          countries: payload.countries,
          events,
        }),
      );
      dispatch(setRequestedCalendarCountriesAction(null));
    });
  };

export default receiveCalendarCountriesEventsOperation;
